import React from 'react';
import { type Page } from '../types';
import Icon from './ui/Icon';

import { type User } from 'firebase/auth';

interface HeaderProps {
  currentPage: Page;
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  onOpenSettings: () => void;
  currentUser?: User | null;
  onSignIn?: () => void;
  onSignOut?: () => void;
  signInLoading?: boolean;
}

const Header: React.FC<HeaderProps> = ({ currentPage, isDarkMode, toggleDarkMode, onOpenSettings, currentUser, onSignIn, onSignOut, signInLoading }) => {
  const pageTitles: Record<Page, string> = {
    dashboard: 'Tổng quan',
    rooms: 'Quản lý phòng',
    tenants: 'Quản lý khách thuê',
    statistics: 'Thống kê',
    guide: 'Hướng dẫn sử dụng',
    backup: 'Sao lưu & Khôi phục',
  };

  return (
    <header className="flex items-center justify-between p-4 sm:p-6 bg-white dark:bg-gray-900 border-b dark:border-gray-700">
      <h1 className="text-xl md:text-2xl font-semibold text-gray-700 dark:text-gray-200 capitalize ml-12 sm:ml-0">{pageTitles[currentPage]}</h1>
      <div className="flex items-center space-x-2 sm:space-x-4">
        <button 
          onClick={toggleDarkMode} 
          className="p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          aria-label={isDarkMode ? "Chế độ sáng" : "Chế độ tối"}
        >
          {isDarkMode ? <Icon name="sun" /> : <Icon name="moon" />}
        </button>
        <button 
          onClick={onOpenSettings} 
          className="p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          aria-label="Cài đặt"
        >
          <Icon name="settings" />
        </button>
        {currentUser ? (
          <div className="flex items-center space-x-2">
            <div className="text-sm text-gray-700 dark:text-gray-200 mr-2">{currentUser.email}</div>
            <button onClick={onSignOut} className="px-3 py-1 text-sm border rounded-md text-gray-700 dark:text-gray-200">Đăng xuất</button>
          </div>
        ) : (
          <button onClick={onSignIn} disabled={signInLoading} className={`px-3 py-1 text-sm border rounded-md text-gray-700 dark:text-gray-200 ${signInLoading ? 'opacity-60 cursor-wait' : ''}`}>
            {signInLoading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
